const FR = {
  LOADING: 'Chargement ...',
  SAVING: 'Enregistrement ...',
  SAVE_COMPLETE: 'Enregistrement terminé',
  ZOOM_IN_ERROR: 'Zoom trop grand.',
  ZOOM_ERROR: 'Impossible de zoomer plus.',
  ONLY_ONE_TOPIC_MUST_BE_SELECTED: 'Impossible de créer un noeud. Un seul noeud doit être sélectionné.',
  ONE_TOPIC_MUST_BE_SELECTED: 'Impossible de créer un noeud. Un noeud parent doit être sélectionné au préalable.',
  ONLY_ONE_TOPIC_MUST_BE_SELECTED_COLLAPSE: 'Un noeud enfant ne peut pas être réduit. Un noeud doit être sélectionné.',
  SAVE_COULD_NOT_BE_COMPLETED: 'Enregistrement impossible. Essayer ultérieurement.',
  MAIN_TOPIC: 'Noeud titre principal',
  SUB_TOPIC: 'Noeud sous-titre',
  ISOLATED_TOPIC: 'Noeud isolé',
  CENTRAL_TOPIC: 'Noeud racine',
  ENTITIES_COULD_NOT_BE_DELETED: "Impossible d'effacer un noeud ou une relation. Au moins un objet de la carte doit être sélectionné.",
  CLIPBOARD_IS_EMPTY: 'Rien à copier. Presse-papier vide.',
  CENTRAL_TOPIC_CAN_NOT_BE_DELETED: 'Le noeud racine ne peut pas être effacé.',
  RELATIONSHIP_COULD_NOT_BE_CREATED: 'Impossible de créer relation. Un noeud parent doit être sélectionné au préalable.',
  SESSION_EXPIRED: 'Votre session a expiré, veuillez vous reconnecter.',
  CENTRAL_TOPIC_CONNECTION_STYLE_CAN_NOT_BE_CHANGED: 'Le style de connexion ne peut pas être modifié pour le sujet central.',
  CENTRAL_TOPIC_STYLE_CAN_NOT_BE_CHANGED: 'Le sujet central ne peut pas être changé en style de ligne.',

};

export default FR;
